import { Injector } from '@angular/core';
import { loadConfiguration } from './startup/load-configuration';
import { startCloudwatchRUM } from './startup/start-cloudwatch-rum';
import { loadVisibilityMonitor } from './startup/load-visibility-monitor';
import { loadAvailabilityMonitor } from './startup/load-availability-monitor';

/**
 * This is anything that needs to run AFTER angular assets are downloaded but BEFORE
 * angular starts.
 * @param injector
 */
export const startupFactory = (injector: Injector) => () => {
	const steps: (StartUpFunction)[] = [
		loadConfiguration,
		loadAvailabilityMonitor,
		startCloudwatchRUM,
		loadVisibilityMonitor
	];

	let index = 0;

	const runNextStep = (): Promise<any> => {
		if (index < steps.length) {
			return steps[index++](injector).then(() => runNextStep());
		}
	};

	return runNextStep();
};

export type StartUpFunction = (x: Injector) => Promise<any>;
